import { CircleChevronRight } from "lucide-react";
import React from "react";
// import { about_img } from "../assets";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const about_points = [
    // "Explore how new technologies can enhance patient care and streamline nursing practices.",
    // "Delve into personalized approaches to gynecology and obstetrics care.",
    // "Address the importance of early detection and treatment of cancer.",
    // "Discuss the latest developments in women's health, reproductive medicine, Neonatal care etc.",
  ];

  return (
    <div className="flex flex-col md:flex-row gap-2 md:h-[80vh] bg-pimary items-center justify-center p-4 md:px-12 md:py-4">
      {/* Image Section */}
      <div className="flex justify-center">
        <img
          src="https://img.freepik.com/free-photo/dentist-doing-check-up-patient_23-2149206225.jpg?uid=R75564813&ga=GA1.1.1422450455.1747647704&semt=ais_hybrid&w=740"
          alt="Dental Conference 2025"
          loading="lazy"
          className="h-[80%] md:max-h-[100%] w-auto md:w-[80vh] md:mx-16 rounded-2xl object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col w-full md:w-2/3">
        <h1 className="text-xl md:text-3xl font-bold my-2">
          <span className="text-one">
            Discover Top Public Health Events with
          </span>{" "}
          Helix Conferences
        </h1>
        <p className="text-base my-2">
          We are proud to host and curate some of the top <Link className="text-one font-bold" to="/about-public-health-conclave">Public Health
          Conferences</Link> that bring together Global Leaders, Innovators,
          Researchers, and Healthcare Professionals. Our mission is to advance
          public health knowledge, foster international collaboration, and
          support evidence-based solutions to today’s most pressing health
          challenges.
        </p>
        <blockquote className="italic text-one my-2 border-l-4 border-one pl-4">
          “Helix Conferences is where you meet the world at it's best.”
        </blockquote>
        {/* <div className="flex flex-col gap-3 mt-4">
          {about_points.map((item, idx) => (
            <div key={idx} className="flex flex-row gap-2 items-start">
              <CircleChevronRight
                size={24}
                className="text-one flex-shrink-0 mt-1"
              />
              <p className="text-sm md:text-base">{item}</p>
            </div>
          ))}
        </div> */}
        <Link to="/about-public-health-conclave">
          <button className="flex bg-deepBlue text-primary px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
